module.exports = __webpack_public_path__ + "img/info-icon.5df58263.svg";